import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import {COMMIT_CHANGE_LOGIN_MODAL} from "@constants/mutation-type/login-mutation-type";
import {routes} from "@/router/routes";
Vue.use(VueRouter);



const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // 增加百度统计
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', to.fullPath])
        }
    }
    // 判断这个界面是否需要登录后访问
    if (to.meta.needLogin) {
        store.state.login.userInfoPromise.then(() => {
            if (store.state.login.isLogin) {
                next()
            } else {
                store.commit(COMMIT_CHANGE_LOGIN_MODAL, {showLoginModal: true});
                next('/')
            }
        });
    } else {
        next();
    }

});

export default router
